"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _base = require("@atlaskit/icon/base");
var _videoPause = _interopRequireDefault(require("@atlaskit/icon/core/video-pause"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const VidPauseIcon = props => /*#__PURE__*/_react.default.createElement(_base.IconFacade, Object.assign({
  dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M6 4h2a1 1 0 0 1 1 1v14a1 1 0 0 1-1 1H6a1 1 0 0 1-1-1V5a1 1 0 0 1 1-1m10 0h2a1 1 0 0 1 1 1v14a1 1 0 0 1-1 1h-2a1 1 0 0 1-1-1V5a1 1 0 0 1 1-1"/></svg>`
}, props, {
  newIcon: _videoPause.default
}));
VidPauseIcon.displayName = 'VidPauseIcon';
var _default = exports.default = VidPauseIcon;